import { getSetting } from '@disy/workbook.lib/settings';

import type { DataViewDto } from 'cadenza/workbook/api/data-view-dto';
import { getViewType } from 'cadenza/workbook/api/data-view-visualization-key';
import type { DataView } from 'cadenza/workbook/data-view/data-view';
import { CommonDataViewSettingsKey } from 'cadenza/workbook/model/common-data-view-settings-key.gen';
import { DrillThroughDisplayMode } from 'cadenza/workbook/model/drill-through-display-mode.gen';

export function getDrillThroughDisplayModeSetting(dataView: DataView | DataViewDto) {
  const viewType = getViewType(dataView.visualizationKey);
  const defaultDrillThroughDisplayMode = viewType === 'TABLE' ? 'DIRECT' : 'DROPDOWN';
  return DrillThroughDisplayMode.fromPersistenceKey(
    getSetting(
      dataView,
      CommonDataViewSettingsKey.toPersistenceKey('DRILL_THROUGH_DISPLAY_MODE'),
      DrillThroughDisplayMode.toPersistenceKey(defaultDrillThroughDisplayMode),
    ),
  );
}
